import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../modules/shared/shared.module';
import { MigrationComponent } from './migration.component';
import { MigrationPasswordComponent } from './migration-password/migration-password.component';
import { MigrationEmailEntryComponent } from './migraton-email-entry/migration-email-entry.component';
import { MigrationRoutingModule } from './migration-routing.module';
import { MaterialModule } from 'src/app/modules/shared/material/material.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MigrationNotificationModalModule } from './migration-notification-modal/migration-notification-modal.module';
import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';
import { IonicModule } from '@ionic/angular';
import { MigrationLayoutComponent } from './migration-layout/migration-layout.component';

@NgModule({
	imports: [
		CommonModule,
		MigrationRoutingModule,
		SharedModule,
		MaterialModule,
		IonicModule,
		FormsModule,
		ReactiveFormsModule,
		MatPasswordStrengthModule,
		MigrationNotificationModalModule,
	],
	declarations: [
		MigrationComponent,
		MigrationPasswordComponent,
		MigrationEmailEntryComponent,
		MigrationLayoutComponent,
	],
	providers: [],
})
export class MigrationModule {}
